import { render, staticRenderFns } from "./logo-icon-sprite.vue?vue&type=template&id=534bea8e&scoped=true"
import script from "./logo-icon-sprite.vue?vue&type=script&lang=js"
export * from "./logo-icon-sprite.vue?vue&type=script&lang=js"
import style0 from "./logo-icon-sprite.vue?vue&type=style&index=0&id=534bea8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534bea8e",
  null
  
)

/* custom blocks */
import block0 from "./logo-icon-sprite.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(component)

export default component.exports